import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo } from "react";

export const DuplicateBarcodeModal = memo(function DuplicateBarcodeModal({
  barcode,
  onClose,
}: {
  barcode: string;
  onClose: () => void;
}) {
  return (
    <RedoModal
      onModalCloseRequested={onClose}
      primaryButton={{ onClick: onClose, text: "Close" }}
      title="Duplicate item"
    >
      Scanned item {barcode} is already fully scanned.
    </RedoModal>
  );
});
